/* =====================================================================
   X3 — THE MARKS
   N1 — AND THEY ARE NOT ON THE SHEET ANY MORE

   Tommy (IDEAS #22 PROGRESS MARKS): "six logos in a row on the paper
   that are just kind of cryptic and odd. As you hit the Easter eggs, they
   permanently tick off … local storage or similar."

   They were a printed row in the foot of the sheet (X3), then five of
   them (E1), then six again (G2), then a PLAN in the margin above the
   cartouche with the red laid over the black glyph by glyph (G3). N1
   (2026-09-20) takes them off the paper altogether. Tommy: the six
   glyphs "leave the sheet's print and live ON THE NOTE under the map, as
   a plan" — "a real oddity that you discover". So:

     - room-e9/build-furniture.js prints no glyph on the sheet. The band
       above the cartouche is empty margin again.
     - the DRAWINGS are still that generator's GLYPH table, and it writes
       them to src/_data/glyphs.json; base.njk inlines them into the
       note card (#fold-note, deleted by FU2 2026-09-27: they are in the
       margin of the file card's hint list now) — N1's plan of the six (NL1 put one in the
       margin of each line of a ruled list instead on 2026-09-21, and NC1
       put the plan back on 2026-09-22; the list is the day card's now and
       carries no drawings) — and day.js rings and re-inks one as its egg
       lands.
     - THIS FILE IS THE STATE. No container, no per-glyph <svg>, no
       matrix per frame, no re-inking read off the furniture string, no
       `?six=` and no `?prog=`: a page that carries the decision carries
       one way of showing it (Tommy: "please don't keep old querystrings
       once we've made decisions").

   CR1 — AND THE FOUND ONES ARE BACK ON THE SHEET, AS A ROW

   Tommy (2026-09-20): "it's occurred to me that there's no way to see
   any progress on the unfolded sheet now. i want to add the glyphs back
   here but in a straight row in order and they only show WHEN completed,
   so if you do one you'll suddenly notice a weird map mark in a space
   that indicates there could be more."

   So this file draws again, but it draws ONE thing and it draws it into
   the PRINT: a straight row of the FOUND marks in the clear margin above
   the cartouche, struck into the furniture texture the way handle.js's
   section and engine.js's surveyed-to figure are (`Room.furnRegion` /
   `Room.furnPatch`). It is print, so it drapes over the books, folds
   with the paper and is in the fold's raster — none of which a laid DOM
   overlay was. An unfound slot is NOTHING AT ALL, and the pitch is even,
   so the first mark a reader earns stands alone in an empty margin with
   the gaps either side of it saying there is more. Red and ringed (G6), no label, no
   word: the row is the sheet's own ink and the sheet says nothing.
   The DRAWINGS are still the one copy the page holds — the glyph paths
   base.njk inlines from src/_data/glyphs.json (the hint list since FU2) — read off the
   document, never a second table here.

   WHAT IS PUBLISHED IS UNCHANGED. `Room.progress.mark('fold')` is still
   the whole of what an egg has to do, and `has`/`struck`/`all`/`list`/
   `onChange`/`first`/`elapsed`/`ringPath` are what the terminal's `eggs`,
   the board and the note read. What is gone is `where()` and `layout()`,
   which answered in the sheet's units about a print that no longer
   exists, and `window.RoomProgress` (init / lay / prepFurniture), which
   was the paper-laying half of the module.

   THE STATE is a boolean a mark in one localStorage key, and the list of
   marks is not written down here: src/_data/marks.json is the list, the
   page prints it as <script id="survey-marks"> and api/_lib/routes.js
   reads the same file off disk for the board. Nothing anywhere counts
   them — add or drop one there and the note's plan, the day card's
   hints, the terminal's `eggs` and the board all follow.
   ===================================================================== */
(function () {
'use strict';

/* ---- THE NAMES, AND WHERE THEY COME FROM (X6 a) -------------------
   The fallback below is the same six in the same order: the module has to
   be able to stand on its own in a page that was not built by Eleventy (a
   harness fragment), and a list read off the document is a list that can
   be absent. It is never a SECOND list in practice — if the two ever
   disagree the printed one wins, and `Room.progress.src` says which was
   used. */
var NAMES = ['handle', 'harbour', 'doom', 'fold', 'laptop', 'board'];
var NAMES_SRC = 'fallback';
(function () {
  var el = document.getElementById('survey-marks');
  if (!el) return;
  try {
    var j = JSON.parse(el.textContent || '[]');
    /* E1: AND THE COUNT IS NOT WRITTEN DOWN HERE. This read used to
       demand exactly six, which is the line that turned "drop an egg"
       into an edit in four files. Any non-empty list of names is the
       document's answer now. (G3 briefly sent an object, {names, layout,
       box}; N1 sends the bare array again, and both shapes are read, so
       a stale page cannot end up on the fallback in silence.) */
    if (Object.prototype.toString.call(j) === '[object Array]' && j.length) {
      NAMES = j.map(String); NAMES_SRC = 'document';
    } else if (j && j.names && j.names.length) {
      NAMES = j.names.map(String); NAMES_SRC = 'document';
    }
  } catch (e) { /* the fallback stands */ }
})();

/* ---- THE RING (X12) ------------------------------------------------
   A ring round a mark is not a circle and must not be one: a <circle> at
   this size reads as a computer's O over a hand's drawing, which is the
   one thing this desk may never look like. So it is a stroke a hand made
   — the pen starts somewhere near the top, runs round out of round (two
   low harmonics on the radius, a squashed and tilted axis, the centre off
   by up to four tenths of a unit), and LIFTS before it closes, leaving
   the sheet's own kind of gap. A ring a mark and every one a different
   stroke: the seed is the mark's index, so they are fixed for ever and no
   two are the same hand.

   IT IS GENERATED, NOT STORED, and cheap enough that size is the only
   axis worth arguing on: six took 0.097 ms to generate (measured at his
   dpr, 100 rounds of the six), nothing per frame and nothing per pointer
   move. Stored they would be ~736 B of path data each against ~1.5 kB of
   generator. It is generated because the ring is a TASTE that is still
   open, and because generated rings are provably different strokes,
   which pasted ones are only as long as nobody tidies them.

   IT IS DRAWN IN THE GLYPH'S OWN 20-UNIT BOX, which is the box the
   drawings are in (glyphs.json) wherever they are laid — the sheet's
   print before N1, N1's plan on the note after it (NL1's list margin
   between 2026-09-21 and NC1). R = 12 clears every glyph's corner, and
   the stroke reaches about 3.3 units outside the box, which is why the
   plan's svg is left with its overflow visible (styles.css `.nc-plan
   svg`) and why the row below pads by 10.

   22 SPANS AND TWO DECIMALS. Both were taken down (14 spans, one decimal:
   381 B a ring instead of 736) and both were put back, on the picture:
   a Catmull-Rom's tangent is the chord of its neighbours, so a control
   point rounded to a tenth of a unit is 0.4 % of the radius out of place
   and the joins show it at his dpr. The whole generator is a tenth of a
   millisecond either way. */
function seeded(seed) {                       /* mulberry32 — fixed, tiny */
  var a = seed >>> 0;
  return function () {
    a = (a + 0x6D2B79F5) | 0;
    var t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
function r2(v) { return Math.round(v * 100) / 100; }
function ringPath(i) {
  var q = seeded(0x51C + i * 977);
  var R = 12,                                 /* clears every glyph's corner */
      cx = 10 + (q() - 0.5) * 0.5, cy = 10 + (q() - 0.5) * 0.5,
      e1 = 0.022 + q() * 0.024, p1 = q() * 6.2832,
      e2 = 0.010 + q() * 0.018, p2 = q() * 6.2832,
      tilt = (q() - 0.5) * 0.5,
      a0 = (-118 + q() * 96) * Math.PI / 180, /* the pen goes down near the top */
      sweep = (360 - (26 + q() * 26)) * Math.PI / 180,
      N = 22, pts = [], k, t, rr, x, y;
  for (k = 0; k <= N; k++) {
    t = a0 + sweep * (k / N);
    rr = R * (1 + e1 * Math.cos(t + p1) + e2 * Math.cos(2 * t + p2));
    x = rr * Math.cos(t); y = rr * 0.97 * Math.sin(t);
    pts.push([cx + x * Math.cos(tilt) - y * Math.sin(tilt),
              cy + x * Math.sin(tilt) + y * Math.cos(tilt)]);
  }
  /* one smooth stroke through them (Catmull-Rom as cubics), not 22 chords:
     a chorded ring shows its facets at his dpr. */
  var d = 'M' + r2(pts[0][0]) + ' ' + r2(pts[0][1]), j, A, B, C, D;
  for (j = 0; j < N; j++) {
    A = pts[j > 0 ? j - 1 : 0]; B = pts[j]; C = pts[j + 1];
    D = pts[j + 2 < pts.length ? j + 2 : pts.length - 1];
    d += 'C' + r2(B[0] + (C[0] - A[0]) / 6) + ' ' + r2(B[1] + (C[1] - A[1]) / 6) +
         ' ' + r2(C[0] - (D[0] - B[0]) / 6) + ' ' + r2(C[1] - (D[1] - B[1]) / 6) +
         ' ' + r2(C[0]) + ' ' + r2(C[1]);
  }
  return d;
}

var KEY = 'tl-survey-progress';       /* one key, a comma-separated list */
/* ==== W2-F — THE FIRST-VISIT STAMP ==================================
   The roadmap's ruling: "a first-visit stamp in localStorage; elapsed-to-
   complete travels with the board entry." One more key beside the marks,
   written ONCE — the first load that ever reads it and finds nothing —
   and never again, so it is the day the room was first opened and not the
   last. Guarded exactly as the marks are: localStorage throws outright in
   a third-party frame and in some private windows, and a room that cannot
   be remembered must still be sailed, so an unwritable store means the
   stamp is this session's own and the elapsed reads as the visit. */
var FIRST_KEY = 'tl-survey-first';
var firstMs = 0;
function firstStamp() {
  if (firstMs) return firstMs;
  var raw = '';
  try { raw = localStorage.getItem(FIRST_KEY) || ''; } catch (e) { /* no store */ }
  var n = parseInt(raw, 10);
  if (!isFinite(n) || n <= 0) {
    n = Date.now();
    try { localStorage.setItem(FIRST_KEY, String(n)); } catch (e) { /* this session only */ }
  }
  firstMs = n;
  return n;
}

/* ==== WM2 — THE JOURNAL: WHEN, AND BY WHICH DOOR =====================
   Tommy, 2026-09-22: the site doubles as a benchmark — "hand the whole
   site from the start over to an agent as a form of eval/benchmark ... to
   see how quickly it can work its way through the site". A benchmark
   needs a record of the run, and the record a room can honestly keep is:
   when this browser first opened the door, when each mark was struck, and
   WHICH DOOR struck it.

   THERE ARE THREE DOORS and they are the same three the room has always
   had: a pair of HANDS on the glass, a TOOL called on the page (webmcp.js
   sets this at the top of every execute, through `call`), and the LINK —
   a command arriving over the relay from an agent somewhere else
   (terminal.js sets that one). The door is STICKY: it is the last actor,
   not a guess, so a mark struck by a hand while an agent is watching is a
   hand's mark and reads as one. A document-level capture listener takes
   the hand back the instant the reader touches anything, which is the
   only way a page can know a person is there.

   IT IS STATE, NOT A MEASUREMENT. Nothing here times anything or scores
   anything: `since` is the first-visit stamp W2-F already keeps, `at` is
   the wall clock at the strike, `calls` counts tool executes and nothing
   else. What a harness makes of the three is the harness's own business.

   PERSISTED BESIDE THE MARKS, in one key, guarded exactly as the marks
   are — localStorage throws outright in a third-party frame and in some
   private windows, and a room that cannot be remembered must still be
   sailed. A journal that cannot be written is this session's own.
   ==================================================================== */
var JKEY = 'tl-survey-journal';
var DOORS = { hand: 1, tool: 1, link: 1 };
var jrn = null;
function jread() {
  var raw = '';
  try { raw = localStorage.getItem(JKEY) || ''; } catch (e) { /* no store */ }
  var j = null;
  try { j = raw ? JSON.parse(raw) : null; } catch (e) { j = null; }
  if (!j || typeof j !== 'object') j = {};
  return { door: DOORS[j.door] ? j.door : 'hand',
           calls: (typeof j.calls === 'number' && j.calls > 0) ? (j.calls | 0) : 0,
           marks: (j.marks && typeof j.marks === 'object') ? j.marks : {} };
}
function jwrite() {
  try { localStorage.setItem(JKEY, JSON.stringify(jrn)); }
  catch (e) { /* the journal stands for this session and no longer */ }
}
function ensureJrn() { if (!jrn) jrn = jread(); return jrn; }
/* the hand takes the room back on any touch of it. Capture, so a
   listener that stops propagation cannot hide the reader; passive, so
   none of the three can cost a frame. One property write and no more. */
function handDoor() { ensureJrn().door = 'hand'; touchAct(); }
try {
  ['pointerdown', 'wheel', 'keydown'].forEach(function (t) {
    document.addEventListener(t, handDoor, { capture: true, passive: true });
  });
} catch (e) { /* a document that takes no listeners is a document nobody touches */ }

/* ==== TK1 — THE ACTIVE CLOCK ========================================
   Tommy, 2026-09-24: the board measures "the total amount of time it took
   them to clear the entire obstacle course", and "you could go to my page
   today, you could come back two weeks later, and that would count as two
   weeks, whereas really, that's not the time we want to measure". So this
   is not the first-visit stamp's wall clock: it is ACTIVE time, summed
   across every visit, in one key.

   A second counts when the tab is visible AND something is happening: a
   hand touched the page in the last two minutes, or a command came over
   the link or a page tool ran (both set the door, below), or the boat is
   sailing (a reader watching her go is playing). It stops for good when
   the sixth mark is struck — the course is cleared and the card's time
   is fixed — and the sixth mark's stamp carries it to the server.

   Ticked once a second, never more than two seconds a tick (a machine that
   slept does not bank the sleep), written every five and when the tab
   goes. Guarded like every key here: a store that cannot be written keeps
   the clock for this session. */
var AKEY = 'tl-survey-active';
var IDLE_MS = 120000;
var activeMs = 0, lastAct = Date.now(), lastTick = Date.now(), unsaved = 0;
(function () {
  var n = NaN;
  try { n = parseInt(localStorage.getItem(AKEY) || '', 10); } catch (e) { /* no store */ }
  activeMs = isFinite(n) && n > 0 ? n : 0;
})();
function touchAct() { lastAct = Date.now(); }
function saveActive() {
  unsaved = 0;
  try { localStorage.setItem(AKEY, String(Math.round(activeMs))); } catch (e) { /* this session only */ }
}
function sailing() {
  try {
    var V = window.Room && window.Room.voyage;
    return !!(V && V.state && V.state().state === 'sailing');
  } catch (e) { return false; }
}
function tick() {
  var now = Date.now(), dt = Math.min(2000, Math.max(0, now - lastTick));
  lastTick = now;
  if (API.all()) return;                                  /* cleared: the clock is stopped */
  if (document.visibilityState && document.visibilityState !== 'visible') return;
  if (now - lastAct > IDLE_MS && !sailing()) return;
  activeMs += dt; unsaved += dt;
  if (unsaved >= 5000) saveActive();
}
try {
  document.addEventListener('pointermove', touchAct, { capture: true, passive: true });
  document.addEventListener('visibilitychange', function () { lastTick = Date.now(); saveActive(); });
  window.addEventListener('pagehide', saveActive);
} catch (e) { /* a document that takes no listeners is a document nobody touches */ }

/* ==== TK1 — THE SIGNED RUN ===========================================
   Tommy's "old-school .NET view state": each mark, once struck, is sent
   to /api/progress with the token this browser holds, and the server
   stamps it with its own clock (and this clock's reading), signs the lot
   and hands it back (api/_lib/progress.js). The card on the board is
   written off that token and nothing else. `board` is only stamped for a
   link session whose relay carried `room curtains`, so its request
   carries the session (terminal.js's).

   A mark that could not be stamped — the endpoint unreachable, or the
   sixth before the relay saw the curtains — stays struck here and is tried
   again on the next load, or when something calls `sync()` (the curtains
   over the link do). A token the server no longer recognises (a rotated
   secret) is dropped once and the run is stamped afresh from the marks. */
var TKEY = 'tl-survey-token';
var token = '';
try { token = localStorage.getItem(TKEY) || ''; } catch (e) { /* no store */ }
function setToken(t) {
  token = t || '';
  try { if (token) localStorage.setItem(TKEY, token); else localStorage.removeItem(TKEY); }
  catch (e) { /* the run stands for this session */ }
}
/* the marks the token holds, read off its own body (base64url JSON); the
   signature is the server's business, this is only which marks are in */
function stamped() {
  if (!token) return [];
  try {
    var b = token.split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
    var p = JSON.parse(atob(b + '==='.slice((b.length + 3) % 4)));
    return NAMES.filter(function (n) { return p.eggs && p.eggs[n]; });
  } catch (e) { return []; }
}
function apiBase() {
  var m = /[?&]api=([^&]*)/.exec(location.search);
  return ((m ? decodeURIComponent(m[1]) : '') || location.origin).replace(/\/+$/, '');
}
function linkSession() {
  try { return (window.RoomTerm && RoomTerm.session && RoomTerm.session()) || ''; } catch (e) { return ''; }
}
/* `runGen` moves on at a reset, so an answer to a request made for the run
   before it is dropped rather than folded into the new one (found on his
   Chrome: a stamp in flight across `reset()` put an old mark back) */
var syncing = false, again = false, skip = {}, restarted = false, runGen = 0;
function sync() {
  if (syncing) { again = true; return; }
  if (!window.fetch) return;
  var have = stamped();
  var todo = API.struck().filter(function (n) { return have.indexOf(n) < 0 && !skip[n]; });
  if (!todo.length) return;
  var n = todo[0], gen = runGen;
  syncing = true; again = false;
  var moved = false;
  fetch(apiBase() + '/api/progress', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ token: token, mark: n, active: Math.round(activeMs), session: linkSession() })
  }).then(function (r) { return r.json(); }).then(function (j) {
    if (gen !== runGen) { moved = true; return; }          /* a run that has been reset */
    if (j && j.ok && j.token) { setToken(j.token); moved = true; return; }
    if (j && j.message === 'that record does not verify.' && !restarted) {
      restarted = true; setToken(''); moved = true; return;
    }
    skip[n] = 1;                               /* refused: not again this load */
    moved = true;
  }).catch(function () {
    /* unreachable: every mark waits for the next load */
    API.struck().forEach(function (m) { skip[m] = 1; });
  }).then(function () {
    syncing = false;
    if (moved || again) sync();
  });
}

var set = null;

/* ---- THE STATE -----------------------------------------------------
   localStorage throws outright in a third-party frame and in some private
   windows, and an egg that cannot be remembered must still be findable,
   so every touch of it is guarded and the session's own set is the truth
   while the page is open. */
function read() {
  var raw = '';
  try { raw = localStorage.getItem(KEY) || ''; } catch (e) { /* no store */ }
  var out = {};
  raw.split(',').forEach(function (n) {
    n = n.trim();
    if (n && NAMES.indexOf(n) >= 0) out[n] = 1;
  });
  return out;
}
function write() {
  var list = NAMES.filter(function (n) { return set[n]; });
  try {
    if (list.length) localStorage.setItem(KEY, list.join(','));
    else localStorage.removeItem(KEY);
  } catch (e) { /* the mark stands for this session and no longer */ }
}
function ensureSet() { if (!set) set = read(); return set; }

/* ---- AND WHO IS LOOKING AT THE STATE (X2b, N1) --------------------
   Since N1 there is exactly one thing that DRAWS these marks — the note
   under the map (day.js: N1's plan, NL1's ruled list) — and a mark
   landing while the reader is looking at the card has to ring its glyph,
   strike its line and write out the next one there and then. (N2 added a
   second READER of the state, the day card's next hint; NL1 deleted it,
   so the note is the only one again.) `has(name)` is the read accessor;
   this is the KNOCK — the state changed, ask again. One array, called
   after the state is written, and a watcher that throws does not take the
   next one down with it. Nothing here counts or names marks: what a
   watcher does with the news is the watcher's own business. */
var watchers = [];
function fire() {
  for (var i = 0; i < watchers.length; i++) {
    try { watchers[i](); } catch (e) { /* a watcher's fault is its own */ }
  }
}

/* ---- THE API -------------------------------------------------------
   `Room.progress.mark('fold')` is the whole of what an egg has to do.
   It is idempotent, it persists, and it returns whether this call was the
   one that struck the mark, so a caller can make a noise about it (or
   not) without reading the state first. */
var API = {
  /* X6 (a): `list()` IS THE CANONICAL LIST — marks.json's `names`, in the
     order of finding — the one list the rest of the page, the board and
     an agent all read. `names` is kept as the same array under X3's own
     name (nothing published is taken away), and the STRUCK ones are
     `struck()`. */
  names: NAMES.slice(),
  src: NAMES_SRC,
  list: function () { return NAMES.slice(); },
  has: function (n) { return !!ensureSet()[n]; },
  struck: function () { ensureSet(); return NAMES.filter(function (n) { return set[n]; }); },
  all: function () { ensureSet(); return NAMES.every(function (n) { return set[n]; }); },
  mark: function (n) {
    if (NAMES.indexOf(n) < 0) return false;
    /* EG1 (2026-10-02): a phone earns the marks its hand can reach (the
       pit's, a stranger's handle). PH5 refused them all, and the pit then
       stood up on a phone with no card for it. Tommy: "we deliberately
       disabled all the Easter eggs, but you've missed this one ... I would
       like to have a think about which Easter eggs might work fine through
       mobile". The rest come as the phone gets them. */
    ensureSet();
    if (set[n]) return false;
    set[n] = 1;
    write();
    /* WM2: and the journal takes the moment and the door it came by. It
       is written on the FIRST strike only — `mark` has already answered
       false above for a mark that stood — so a reload cannot re-date it. */
    ensureJrn();
    jrn.marks[n] = { at: new Date().toISOString(), door: jrn.door };
    jwrite();
    /* TK1: the sixth stops the clock, and every mark goes to be signed */
    saveActive();
    fire();
    try { sync(); } catch (e) { /* the mark stands; the stamp waits */ }
    return true;
  },
  unmark: function (n) {
    ensureSet();
    if (!set[n]) return false;
    delete set[n];
    write();
    ensureJrn();
    delete jrn.marks[n];
    jwrite();
    fire();
    return true;
  },
  reset: function () {
    set = {};
    write();
    /* WM2: the journal goes with them. A reset room is a room nobody has
       been in, and a journal of a run that has been wiped is a lie. The
       first-visit stamp is NOT cleared: it is when this browser first
       opened the door, which resetting the marks does not undo. */
    ensureJrn();
    jrn.marks = {}; jrn.calls = 0;
    jwrite();
    /* TK1: and the run with them — a new run, a new clock, a new token */
    activeMs = 0; saveActive(); setToken(''); skip = {}; restarted = false; runGen++;
    fire();
    return true;
  },
  /* X2b: tell me when that changes. Idempotent (the same function is
     never added twice) and it hands the function back, so a caller can
     register and sync in one line. */
  onChange: function (fn) {
    if (typeof fn === 'function' && watchers.indexOf(fn) < 0) watchers.push(fn);
    return fn;
  },
  /* X12 / N1: the ring's own generator, published because the thing that
     DRAWS a ring is no longer this file. day.js asks for one per mark, by
     index, and wears the string it gets; the harness can time it. It
     takes the index, it is pure, and it answers in the glyph's own
     20-unit box. */
  ringPath: function (i) { return ringPath(i | 0); },
  /* W2-F: when this reader first opened the room (ms since the epoch) —
     the journal's `since`. TK1: the board's clock is `active` below, not
     the wall clock since then, which `elapsed` was. */
  first: function () { return firstStamp(); },
  /* ---- TK1: the active clock (ms), the signed run, and the push ------ */
  active: function () { return Math.round(activeMs); },
  token: function () { return token; },
  stamped: function () { return stamped(); },
  sync: function (fresh) {
    if (fresh) skip = {};
    try { sync(); } catch (e) { }
  },

  /* ---- WM2: THE THREE DOORS, AND THE RUN ---------------------------
     `door()` reads the last actor, `door(d)` sets it, `call(d)` sets it
     and counts one tool execute. Anything outside the three names is
     ignored rather than written, so a caller cannot invent a fourth door
     by typo. */
  door: function (d) {
    ensureJrn();
    if (d !== undefined && DOORS[d]) { jrn.door = d; touchAct(); }
    return jrn.door;
  },
  call: function (d) {
    ensureJrn();
    touchAct();                                /* TK1: a command or a tool is someone playing */
    if (DOORS[d]) jrn.door = d;
    jrn.calls++;
    jwrite();
    return jrn.calls;
  },
  /* the run as it stands: when this browser first opened the room, who
     touched it last, how many tool calls there have been, and every mark
     that is STRUCK with the moment and the door of its striking. Marks
     that are not struck are not in it — an empty slot is nothing at all,
     the same rule the row on the sheet follows. */
  journal: function () {
    ensureSet(); ensureJrn();
    var out = {}, i, n;
    for (i = 0; i < NAMES.length; i++) {
      n = NAMES[i];
      if (!set[n]) continue;
      var m = jrn.marks[n];
      out[n] = { at: (m && m.at) || null, door: (m && m.door) || null };
    }
    return { since: new Date(firstStamp()).toISOString(),
             door: jrn.door, calls: jrn.calls, marks: out };
  }
};

/* ==== CR1 — THE ROW OF FOUND MARKS, STRUCK INTO THE PRINT ==========
   WHERE. The clear margin above the cartouche, which is the plan's old
   home (G3) and has been empty paper since N1. The row is centred on the
   CARTOUCHE'S OWN CENTRE — 1182 in the sheet's root units (2364 x 1216),
   which is handle.js's BOX centre 960 carried through the over layer's
   transform — so it stands square over the box the reader types into.

   WHAT IT HAD TO CLEAR, measured off the pristine print at the fit (the
   furniture raster read back through furnPatch, 2026-09-20): the last
   full-width rule under the section panel at y 959.3, and the cartouche's
   volutes, whose topmost ink is at y 1087.7 with its own rule at 1097.8.
   Between them is 128 units of clean paper the whole width of the row.
   The marks are E2's size — a 30-unit box on a 46-unit pitch, Tommy's
   "maybe we should make the Easter egg glyphs bigger. They're currently
   just these weird tiny little icons!" — which is 260 units for six, and
   the band they stand in is set at y 1008 so the row sits centred in that
   clean paper: 41 units below the rule and 42 above the volutes. Nothing
   had to be shrunk or moved up.

   THE INK IS THE PRINT'S. `.sv-pg` is the class the generator printed
   these same drawings under before N1, at the same weights (0.9 / 0.62 /
   0.55 inside the glyph's own 20-unit box) in the sheet's own --ink-2 and
   --ink-3. An SVG rastered through an <img> sees no stylesheet of the
   page's, so the three rules ride inside the markup; there is no <text>
   in it, so it needs no face and no `Room.printFace`.

   NOTHING IS STRUCK WHILE NOTHING IS FOUND. The strike is keyed on the
   struck list and the region's texel size, so a fresh reader's margin is
   the pristine print, byte for byte, and no patch is registered at all.
   ==================================================================== */
var ROW = { cx: 1182, top: 1008, box: 30, pitch: 46, pad: 10 };   /* pad: the ring reaches ~3.5 units past the box */
var GLYPH_BOX = 20;                   /* glyphs.json `box` — the drawings' own */
/* G6 (2026-09-20), Tommy: "the glyphs on the main sheet that only show
   when completed should be the red ticked versions". So a found mark in
   the row is what a found mark was on the note (deleted by FU2):
   the same drawing gone over in the revision red at a corrected line's
   weight (0.9 -> 1.5, 0.62 -> 1, 0.55 -> .85), ringed by its own hand-drawn
   ring (ringPath, the X12 generator, R 12 in the glyph's 20-unit box). The
   ink rules stay for the record; nothing in the row is drawn in them now. */
var ACCENT = '#96322a';
var ROW_INK =
  '.sv-pg{fill:none;stroke:#55483a;stroke-width:.9;stroke-linecap:butt;stroke-linejoin:miter}' +
  '.sv-pg .sv-pg-fill{fill:#55483a;stroke:#55483a;stroke-width:.55}' +
  '.sv-pg .sv-pg-faint{stroke:#7d6d59;stroke-width:.62}' +
  '.sv-pg.is-found{stroke:' + ACCENT + ';stroke-width:1.5}' +
  '.sv-pg.is-found .sv-pg-fill{fill:' + ACCENT + ';stroke:' + ACCENT + ';stroke-width:.85}' +
  '.sv-pg.is-found .sv-pg-faint{stroke:' + ACCENT + ';stroke-width:1}' +
  '.np-ring{fill:none;stroke:' + ACCENT + ';stroke-width:1.15;stroke-linecap:butt;stroke-linejoin:round}';
/* the row's own rectangle, in root sheet units — derived from the list,
   never written down, so a mark added to or dropped from marks.json moves
   the row and its patch together */
function rowBox() {
  var w = (NAMES.length - 1) * ROW.pitch + ROW.box;
  return { x: ROW.cx - w / 2 - ROW.pad, y: ROW.top - ROW.pad,
           w: w + 2 * ROW.pad, h: ROW.box + 2 * ROW.pad };
}
function rowX(i) {
  return ROW.cx + (i - (NAMES.length - 1) / 2) * ROW.pitch - ROW.box / 2;
}
/* THE DRAWINGS, READ OFF THE DOCUMENT. base.njk inlines glyphs.json into
   the file card's hint list, one drawing in the margin of each line
   (FU1/FU2, 2026-09-27: `#dc-list .dc-line[data-mark]`, the paths inside
   its `.dc-g .np-ink`). They were read off the note under the map
   (#fold-note) until FU2 deleted it. That is the page's one copy of
   these paths and this file takes it from there rather than keeping a
   second. Serialised once. */
var glyphSrc = null;
function glyphs() {
  if (glyphSrc) return glyphSrc;
  var g = document.querySelectorAll('#dc-list .dc-line[data-mark]');
  if (!g.length) return null;
  var ser = new XMLSerializer(), out = {}, i, k, kids, d, ink;
  for (i = 0; i < g.length; i++) {
    ink = g[i].querySelector('.np-ink') || g[i];
    kids = ink.childNodes; d = '';
    for (k = 0; k < kids.length; k++) if (kids[k].nodeType === 1) d += ser.serializeToString(kids[k]);
    if (d) out[g[i].getAttribute('data-mark')] = d;
  }
  glyphSrc = out;
  return out;
}
function rowMarkup(found, R) {
  var G = glyphs();
  if (!G) return null;
  var sc = (ROW.box / GLYPH_BOX).toFixed(4), body = '', i, n;
  for (i = 0; i < NAMES.length; i++) {
    n = NAMES[i];
    if (found.indexOf(n) < 0 || !G[n]) continue;    /* an unfound slot is nothing at all */
    body += '<g class="sv-pg is-found" data-mark="' + n + '" transform="translate(' +
      rowX(i).toFixed(3) + ',' + ROW.top.toFixed(3) + ') scale(' + sc + ')">' +
      '<path class="np-ring" d="' + ringPath(i) + '"></path>' + G[n] + '</g>';
  }
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + R.rx.toFixed(4) + ' ' +
    R.ry.toFixed(4) + ' ' + R.rw.toFixed(4) + ' ' + R.rh.toFixed(4) +
    '" width="' + R.pw + '" height="' + R.ph + '">' +
    '<style>' + ROW_INK + '</style>' + body + '</svg>';
}
/* the drawFn furnPatch keeps and re-applies after every re-cut of the
   print; a print re-cut at ANOTHER scale (a resize) gets the old raster
   for one frame and a fresh strike straight after, as the section does */
var rowKey = '', rowGen = 0, rowImg = null, rowMs = 0, rowOn = 0, rowLast = null;
function rowDraw(ctx, R) {
  if (!rowImg) return;                        /* a wipe back to the pristine print */
  ctx.drawImage(rowImg, 0, 0);
  if (rowImg.width !== R.pw || rowImg.height !== R.ph) {
    rowKey = ''; setTimeout(strikeRow, 0);
  }
}
function strikeRow() {
  if (!window.Room || !Room.furnRegion) return false;
  var B = rowBox(), R = Room.furnRegion(B.x, B.y, B.w, B.h);
  if (!R) return false;                        /* no print yet: nothing to strike into */
  var found = API.struck();
  var key = found.join(',') + ':' + R.pw + 'x' + R.ph;
  if (key === rowKey) return true;
  var t0 = (window.performance && performance.now) ? performance.now() : 0;
  if (!found.length) {
    /* nothing found: the margin is paper. Only a row that was struck has
       anything to take off it, and taking it off is the pristine print
       drawn back with nothing over it. */
    rowKey = key;
    rowImg = null; rowLast = null;
    if (rowOn) { Room.furnPatch(B.x, B.y, B.w, B.h, rowDraw); rowOn = 0; }
    return true;
  }
  var svg = rowMarkup(found, R);
  if (!svg) return false;                      /* the drawings are not in the document */
  rowKey = key;
  var gen = ++rowGen;
  var url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' })), img = new Image();
  img.onload = function () {
    URL.revokeObjectURL(url);
    if (gen !== rowGen) return;                /* a later mark is in flight */
    rowImg = img;
    if (!Room.furnPatch(B.x, B.y, B.w, B.h, rowDraw)) { rowKey = ''; return; }
    rowOn = 1;
    rowMs = t0 ? +(performance.now() - t0).toFixed(2) : 0;
    rowLast = { marks: found, box: B, texels: [R.px, R.py, R.pw, R.ph], ms: rowMs };
  };
  img.onerror = function () { URL.revokeObjectURL(url); if (gen === rowGen) rowKey = ''; };
  img.src = url;
  return true;
}
/* THE ONE MOMENT IT IS RE-STRUCK: a mark landing or being taken back,
   through the module's own knock. engine.js calls `strike` once more, the
   moment the print first exists, for the marks a reader already had. */
API.strike = function () { try { return strikeRow(); } catch (e) { return false; } };
API.row = function () {
  return { box: rowBox(), at: ROW.cx, top: ROW.top, size: ROW.box, pitch: ROW.pitch,
           on: !!rowOn, ms: rowMs, last: rowLast };
};
API.onChange(function () { strikeRow(); });

window.Room = window.Room || {};
window.Room.progress = API;
/* W2-F: and it is stamped on the first load, not on the first egg — the
   clock starts when the reader arrives, which is what "first visit"
   means. It is one read and at most one write of one key. */
try { firstStamp(); } catch (e) { /* the room is still a room */ }
/* TK1: the clock ticks from the first load, and a mark struck while the
   endpoint could not be reached is sent again a moment after boot */
try {
  setInterval(tick, 1000);
  setTimeout(function () { try { sync(); } catch (e) { } }, 4000);
} catch (e) { /* a harness page with no timers keeps the marks and no clock */ }
})();
